export class AlertHistoryRequestModel {
    public config = '';
    public startTime: Date | null = null;
    public endTime: Date | null = null;
    public maxCount = 0;
    public startId = '';
}